import { useEffect, useState } from 'react';
import Button from '../common/Button';

function Header({ 
    searchTerm, 
    onSearch, 
    onShowFilters, 
    onClearFilters, 
    hasActiveFilters,
    sortBy,
    onSortChange,
    sortOptions = [],
    // Mobile mode signal (controls are rendered in MobileBottomBar)
    mobileView
}) {
    const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);
    const isMobileHeader = mobileView !== undefined;

    useEffect(() => {
        setLocalSearchTerm(searchTerm);
    }, [searchTerm]);

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        onSearch(localSearchTerm);
    };

    const handleClearSearch = () => {
        setLocalSearchTerm('');
        onSearch('');
    };

    return (
        <header className="gw-bp-geosearch-header">
            <div className="search-section">
                <form onSubmit={handleSearchSubmit} className="search-form">
                    <div className="search-input-wrapper">
                        <input
                            type="text"
                            value={localSearchTerm}
                            onChange={(e) => setLocalSearchTerm(e.target.value)}
                            placeholder="Search members..."
                            className="search-input"
                        />
                        {localSearchTerm && (
                            <button
                                type="button"
                                onClick={handleClearSearch}
                                className="clear-search-btn"
                                aria-label="Clear search"
                            >
                                ×
                            </button>
                        )}
                    </div>
                    <Button type="submit" variant="primary">
                        Search
                    </Button>
                </form>

                {isMobileHeader && (
                    <div className="mobile-sort-row">
                        <label htmlFor="mobile-sort-select" className="mobile-sort-label">Sort</label>
                        <select
                            id="mobile-sort-select"
                            value={sortBy}
                            onChange={(e) => onSortChange(e.target.value)}
                            className="mobile-sort-select"
                            aria-label="Sort members"
                        >
                            {(sortOptions.length > 0 ? sortOptions : [
                                { value: 'joined', label: 'Recently Joined' },
                                { value: 'joined_asc', label: 'Oldest Joined' },
                                { value: 'last_active', label: 'Recently Active' },
                                { value: 'last_active_asc', label: 'Least Recently Active' },
                                { value: 'name', label: 'Name (A-Z)' },
                                { value: 'name_desc', label: 'Name (Z-A)' }
                            ]).map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                )}
            </div>

            {!isMobileHeader && (
                <div className="controls-section">
                    <Button
                        onClick={onShowFilters}
                        variant={hasActiveFilters ? 'primary' : 'secondary'}
                        className={hasActiveFilters ? 'has-active-filters' : ''}
                    >
                        Filters {hasActiveFilters && <span className="filter-indicator">*</span>}
                    </Button>

                    {(hasActiveFilters || searchTerm) && (
                        <Button
                            onClick={onClearFilters}
                            variant="outline"
                            size="small"
                        >
                            Clear All
                        </Button>
                    )}
                </div>
            )}
        </header>
    );
}

export default Header;
